// src/services/capitalize.ts
function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

// src/services/is-string.ts
function isString(value) {
  return typeof value === "string";
}

// src/services/string-conditions.ts
import { notDefined } from "@vy/null";

// src/string-consts.ts
var EMPTY_STRING = "";

// src/services/string-conditions.ts
function isEmptyString(value) {
  return notDefined(value) || value === EMPTY_STRING;
}
function isNotEmptyString(value) {
  return !isEmptyString(value);
}
function whenNotEmptyString(value, fn) {
  if (isEmptyString(value)) {
    return void 0;
  }
  return typeof fn === "function" ? fn(value) : value;
}

// src/services/base64-converters.ts
var convertStringToBase64 = (string) => {
  const buffer = Buffer.from(string);
  return convertBufferToBase64(buffer);
};
var convertBufferToBase64 = (buffer) => {
  return buffer.toString("base64");
};
var convertBase64ToString = (base64) => {
  return Buffer.from(base64, "base64").toString("utf-8");
};

// src/services/normalizeString.ts
function normalizeString(input, separator = "") {
  const lowercasedInput = input.toLowerCase();
  const words = lowercasedInput.split(/\s+/);
  const capitalizedWords = words.map((word) => {
    const firstLetter = word[0];
    const restOfWord = word.slice(1);
    return firstLetter.toUpperCase() + restOfWord;
  });
  return capitalizedWords.join(separator);
}

// src/services/escape-csv-value.ts
function escapeCsvValue(input) {
  const shouldQuote = /^[=+\-@]/.test(input.trimStart()) || /[,"\n\r]/.test(input);
  if (shouldQuote) {
    return `"${input.replace(/"/g, '""')}"`;
  }
  return input;
}

// src/services/escape-regex.ts
function escapeRegex(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// src/services/split-pascal-case.ts
function splitPascalCase(value) {
  return value.replace(/([a-z])([A-Z])/g, "$1 $2");
}

// src/services/stringify-value.ts
import { notDefined as notDefined2 } from "@vy/null";
import { isNumber } from "@vy/number";
function stringifyValue(value) {
  if (notDefined2(value)) {
    return "";
  }
  if (isString(value)) {
    return value;
  }
  if (isNumber(value)) {
    return String(value);
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  return JSON.stringify(value);
}

// src/services/parse-csv-or-json-array.ts
function parseCsvOrJsonArray(rawValue) {
  const trimmed = rawValue.trim();
  if (trimmed.startsWith("[")) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.map(String);
      }
    } catch {
    }
    return trimmed.slice(1, -1).split(",").map((item) => item.trim().replace(/^"|"$/g, ""));
  }
  return trimmed.split(",").map((item) => item.trim());
}
export {
  capitalize,
  convertBase64ToString,
  convertBufferToBase64,
  convertStringToBase64,
  escapeCsvValue,
  escapeRegex,
  isEmptyString,
  isNotEmptyString,
  isString,
  normalizeString,
  parseCsvOrJsonArray,
  splitPascalCase,
  stringifyValue,
  whenNotEmptyString
};
